import { GameSetupConfig } from '../configs/game-setup.config'
import { ViewGame } from '../models/view-game'
import { CancelGameSetupErrorCode } from '../error-codes/cancel-game-setup.error-code'
import { ViewGameDto } from '../dtos/view-game.dto'
import { ViewGamePlayer } from '../models/view-game-player'
import { CommandResponse, QueryErrorCode, QueryResponse } from 'shared-services'
import { ViewGameAsGuest } from '../models/view-game-as-guest'

export class ViewGamesService {
  public constructor(private readonly gameSetupConfig: GameSetupConfig) {}

  public async getGames(): Promise<ViewGame[]> {
    const response = await fetch(
      `${this.gameSetupConfig.apiBaseUrl}/v1/games`,
      {
        credentials: 'include',
      },
    )

    const queryResponse = (await response.json()) as QueryResponse<
      ViewGameDto[],
      QueryErrorCode
    >

    if (!queryResponse.isSuccessful) {
      return []
    }

    return queryResponse.result.map(
      (response) =>
        new ViewGame({
          ...response,
          players: response.players.map((dto) => new ViewGamePlayer(dto)),
        }),
    )
  }

  public async getGamesAsGuest(): Promise<ViewGame[]> {
    const response = await fetch(
      `${this.gameSetupConfig.apiBaseUrl}/v1/games-as-guest`,
      {
        credentials: 'include',
      },
    )

    const queryResponse = (await response.json()) as QueryResponse<
      ViewGameDto[],
      QueryErrorCode
    >

    if (!queryResponse.isSuccessful) {
      return []
    }

    return queryResponse.result.map(
      (dto) =>
        new ViewGameAsGuest({
          ...dto,
          players: dto.players.map(
            (playerDto) => new ViewGamePlayer(playerDto),
          ),
        }),
    )
  }

  public async cancelGameSetup(
    gameShortId: string,
  ): Promise<CommandResponse<CancelGameSetupErrorCode>> {
    const body = {
      gameShortId,
    }

    const response = await fetch(
      `${this.gameSetupConfig.apiBaseUrl}/v1/cancel-game`,
      {
        method: 'POST',
        body: JSON.stringify(body),
        credentials: 'include',
        headers: {
          'Content-Type': 'application/json',
        },
      },
    )

    return (await response.json()) as CommandResponse<CancelGameSetupErrorCode>
  }
}
